import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Redirector() {
  const navigate = useNavigate();
  useEffect(() => {
    setTimeout(() => {
      const redirectPath = sessionStorage.getItem('redirectPath');
      if (redirectPath) {
        sessionStorage.removeItem('redirectPath');
        navigate(redirectPath);
      }
    }, 1);
  }, [navigate]);

  return null;
}
